import { FC, PropsWithChildren, useEffect } from 'react';

import { Stack } from 'libs/ui';

import { CanvasStyled, ContainerStyled, LayoutStyled } from './AuthView.styles';
import { WebGLGradient } from './gradient';

export interface AuthViewProps extends PropsWithChildren {}

export const AuthView: FC<AuthViewProps> = ({ children }) => {
  useEffect(() => {
    // eslint-disable-next-line no-new
    const can = new WebGLGradient('#gradient-canvas');
    can.initGradient('#gradient-canvas');
  }, []);

  return (
    <ContainerStyled>
      <LayoutStyled hideChangePassword hideNavigationMenu hideNotifications>
        <Stack className="auth-content">{children}</Stack>
      </LayoutStyled>
      <div className="auth-right-content">
        <CanvasStyled key="gradient-canvas" id="gradient-canvas" />
      </div>
    </ContainerStyled>
  );
};
